module.exports = __webpack_public_path__ + "static/media/P1000-Tip-Solution-Blue.1c88b29e.svg";